module.exports = __webpack_public_path__ + "img/brand2.11672680.png";